import { call } from "redux-saga/effects";
import { API_URLS } from "../resources/constants";
import { formQueryString } from '../resources/functions';
import { CallApi } from './callApi';

// Five-Year Forecast (gl-api /forecasts). Payload conventions:
//   ids travel as forecastId / lineId; request bodies as `body`; everything
//   else becomes the query string.

const base = API_URLS.FORECAST.LIST;
const qs = (params: any) => {
  const q = formQueryString(params || {});
  return q ? `?${q}` : '';
};

function* run(action: any, fn: any, url: string, body: any = {}): any {
  try {
    const result = yield call(fn, url, body, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e);
  }
}

export function* list(action: any): any {
  yield* run(action, CallApi.GET, base + qs(action.payload));
}

export function* create(action: any): any {
  yield* run(action, CallApi.POST, base, action.payload);
}

export function* details(action: any): any {
  yield* run(action, CallApi.GET, `${base}/${action.payload.forecastId}`);
}

export function* update(action: any): any {
  const { forecastId, body } = action.payload;
  yield* run(action, CallApi.PUT, `${base}/${forecastId}`, body);
}

export function* remove(action: any): any {
  yield* run(action, CallApi.DELETE, `${base}/${action.payload.forecastId}`);
}

export function* categories(action: any): any {
  yield* run(action, CallApi.GET, API_URLS.FORECAST.CATEGORIES + qs(action.payload));
}

export function* addLine(action: any): any {
  const { forecastId, body } = action.payload;
  yield* run(action, CallApi.POST, `${base}/${forecastId}/lines`, body);
}

export function* updateLine(action: any): any {
  const { forecastId, lineId, body } = action.payload;
  yield* run(action, CallApi.PUT, `${base}/${forecastId}/lines/${lineId}`, body);
}

export function* deleteLine(action: any): any {
  const { forecastId, lineId } = action.payload;
  yield* run(action, CallApi.DELETE, `${base}/${forecastId}/lines/${lineId}`);
}

export function* saveMonthlyValues(action: any): any {
  const { forecastId, lineId, values } = action.payload;
  yield* run(action, CallApi.PUT, `${base}/${forecastId}/lines/${lineId}/monthly-values`, { values });
}

export function* results(action: any): any {
  yield* run(action, CallApi.GET, `${base}/${action.payload.forecastId}/results`);
}

/** PDF export: payload { forecastId, type: 'summary' | 'detailed', year }. Resolves with the PDF blob. */
export function* exportPdf(action: any): any {
  const { forecastId, ...params } = action.payload;
  yield* run(action, CallApi.DOWNLOAD, `${base}/${forecastId}/export${qs(params)}`);
}
